module.exports = __webpack_public_path__ + "img/91303.cf039d20.svg";